import { render, staticRenderFns } from "./TicketsSync.vue?vue&type=template&id=bbc94fbc&"
import script from "./TicketsSync.vue?vue&type=script&lang=js&"
export * from "./TicketsSync.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports